import React from "react";
import PropTypes from "prop-types";
import "./ShimmerStyles.css";

/**
 * ShimmerLoading component for displaying loading state with customizable dimensions
 * @param {Object} props Component props
 * @param {string|number} props.width Width of the shimmer element (can be px, %, or any CSS unit)
 * @param {string|number} props.height Height of the shimmer element (can be px, %, or any CSS unit)
 * @param {boolean} props.fullWidth Whether the shimmer should take full width of its container
 * @param {string} props.className Additional CSS classes to apply
 * @param {string} props.borderRadius Border radius of the shimmer element
 * @returns {JSX.Element} ShimmerLoading component
 */
const ShimmerLoading = ({ 
  width = "100px", 
  height = "20px", 
  fullWidth = false, 
  className = "", 
  borderRadius = "4px" 
}) => {
  // Convert numeric values to pixel values
  const widthValue = typeof width === "number" ? `${width}px` : width;
  const heightValue = typeof height === "number" ? `${height}px` : height;
  
  return (
    <div 
      className={`shimmer-effect ${className}`} 
      style={{ 
        width: fullWidth ? "100%" : widthValue, 
        height: heightValue,
        borderRadius: borderRadius
      }} 
      data-testid="shimmer-loading"
    />
  );
};

ShimmerLoading.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  borderRadius: PropTypes.string
};

export default ShimmerLoading;
